export function availableFactory($resource, MyConstant) {
    "ngInject"
    return $resource('', {}, {
        add: {
            url: `${MyConstant.ApiUrl}ECBProductAvailabilityAlert/AddToAvailabilityAlert?productId=:productId`,
            transformResponse: function (data) {
                if (data == 'false') {
                    return { data: false }
                }
                else {
                    return { data: true }
                }
            }
        },
        remove: {
            url: `${MyConstant.ApiUrl}ECBProductAvailabilityAlert/RemoveAvailabilityAlert?productId=:productId`
        },
        query: {
            url: `${MyConstant.ApiUrl}ECBProductAvailabilityAlert/GetAvailabilityAlert`,
            isArray: true
        }
    })
}


// WEBPACK FOOTER //
// ./src/factories/available-alert/available-alert.ts